import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';

const TeamSection = () => {
  const { t } = useTranslation();
  
  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="section-spacing-large bg-white" style={{ paddingBottom: '60px' }}>
      <div className="container-cift">
        {/* Section Label */}
        <div className="text-center mb-12">
          <span className="label-text">{t('team.label')}</span>
          <h2 className="section-title mt-4 mb-6">
            {t('team.headline')}
          </h2>
        </div>

        {/* Team Photos Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12">
          {/* Mustafa Ciftci */}
          <div className="relative group">
            <div className="aspect-[3/4] bg-gray-200 overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_cift-studio-preview/artifacts/c5zs6he2_DSCF9923-3.jpg"
                alt="Mustafa Ciftci - Videograph und Fotograf"
                className="w-full h-full object-cover transition-all duration-500"
              />
            </div>
            <div className="mt-4 text-center">
              <h3 className="font-display font-bold text-xl mb-1">Mustafa Ciftci</h3>
              <p className="text-gray-600 text-sm">{t('team.role.videographer')}</p>
            </div>
          </div>

          {/* Tuba Ciftci */}
          <div className="relative group">
            <div className="aspect-[3/4] bg-gray-200 overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_cift-studio-preview/artifacts/tdwj0i7v_DSCF9964-3.jpg"
                alt="Tuba Ciftci - Fotografin"
                className="w-full h-full object-cover transition-all duration-500"
              />
            </div>
            <div className="mt-4 text-center">
              <h3 className="font-display font-bold text-xl mb-1">Tuba Ciftci</h3>
              <p className="text-gray-600 text-sm">{t('team.role.photographer')}</p>
            </div>
          </div>
        </div>

        {/* Description Text */}
        <div className="max-w-3xl mx-auto text-center">
          <p className="body-text mb-8 leading-relaxed">
            {t('team.body')}
          </p>

          {/* CTA Button */}
          <button 
            onClick={scrollToContact}
            className="btn-primary inline-flex items-center gap-2 group"
          >
            {t('team.cta')}
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
